import type { UserRole } from '@packages/shared-types';
import { Navigate } from 'react-router-dom';

import { LoadingLogo } from '@/components/shared/LoadingLogo';
import { useAuth } from '@/hooks/useAuth';

interface ProtectedRouteProps {
  children: JSX.Element;
  allowedRoles?: UserRole[];
}

export function ProtectedRoute({
  children,
  allowedRoles,
}: ProtectedRouteProps): JSX.Element {
  const { isAuthenticated, isLoading, user } = useAuth();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <LoadingLogo size="lg" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && user && !allowedRoles.includes(user.role)) {
    if (user.role === 'root') {
      return <Navigate to="/tenants" replace />;
    }
    // User role cannot access dashboard; redirect to items
    if (user.role === 'user') {
      return <Navigate to="/items" replace />;
    }
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
